import { Navigate } from 'react-router-dom';
import { RotateCw } from 'lucide-react';
import { useOrg } from '../org/useOrg';
import { useAuth } from '../auth/useAuth';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Shown to an authenticated user who belongs to no workspace — a workspace is
 * provisioned by an admin (and later a subscription), not auto-created. If a
 * workspace appears (an invite is accepted, or an admin adds them), we send
 * them straight into it.
 */
export function NoWorkspacePage() {
  useDocumentTitle('No workspace');
  const { activeOrg } = useOrg();
  const { user, logout } = useAuth();

  if (activeOrg) return <Navigate to={`/w/${activeOrg.slug}`} replace />;

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-sm space-y-4 text-center">
        <div className="flex items-center justify-center gap-2">
          <span className="grid h-7 w-7 place-items-center rounded-[5px] bg-ink text-surface-1">
            <RotateCw className="h-4 w-4" aria-hidden="true" />
          </span>
          <span className="font-display text-sm font-bold tracking-tight text-ink">
            aiai<span className="text-signal">·</span>loop
          </span>
        </div>
        <div className="card space-y-3 p-6">
          <h1 className="text-lg font-semibold text-ink">No workspace yet</h1>
          <p className="text-sm text-ink-muted">
            {user?.email ? (
              <>
                You’re signed in as <span className="font-medium">{user.email}</span>.{' '}
              </>
            ) : null}
            You don’t have access to any workspace. Ask an admin to invite you.
          </p>
          <button type="button" className="btn-secondary w-full" onClick={logout}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
